import { FaGlobe, FaBars,  } from "react-icons/fa6";
import { TbHandClick } from "react-icons/tb";
import { TbBrandWhatsapp } from "react-icons/tb";

export const icons = {
    LanguageIcon: FaGlobe,
    DropdownMenuIcon: FaBars,
    CourserPointerIcon: TbHandClick,
    BrandWhatsapp: TbBrandWhatsapp
}